import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Toolbar from '@mui/material/Toolbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { useShell } from './ShellContext';
export const SIDEBAR_WIDTH = 260;
const SidePanel = ({ open, onClose, bottomSlot }) => {
    const { navItems } = useShell();
    const navigate = useNavigate();
    const location = useLocation();
    const drawerContent = (_jsxs(_Fragment, { children: [_jsx(Toolbar, {}), _jsx(List, { sx: { px: 1.5, pt: 1.5, pb: 1 }, children: navItems.map((item) => {
                    const isSelected = location.pathname.startsWith(item.path);
                    return (_jsxs(ListItemButton, { selected: isSelected, onClick: () => navigate(item.path), sx: {
                            borderRadius: 2,
                            mb: 0.5,
                            py: 1.25,
                            px: 2,
                            '&.Mui-selected': {
                                backgroundColor: 'primary.50',
                                '&:hover': { backgroundColor: 'primary.100' }
                            },
                            '&:hover': { borderRadius: 2 }
                        }, children: [item.icon && (_jsx(ListItemIcon, { sx: {
                                    minWidth: 40,
                                    color: isSelected ? 'primary.main' : 'text.secondary'
                                }, children: item.icon })), _jsx(ListItemText, { primary: item.label, primaryTypographyProps: {
                                    fontSize: '0.95rem',
                                    fontWeight: isSelected ? 600 : 400,
                                    color: isSelected ? 'primary.main' : 'text.primary'
                                } })] }, item.id));
                }) }), _jsx(Box, { sx: { flexGrow: 1 } }), bottomSlot && (_jsxs(_Fragment, { children: [_jsx(Divider, {}), bottomSlot] }))] }));
    return (_jsx(Drawer, { variant: "persistent", open: open, onClose: onClose, sx: {
            width: SIDEBAR_WIDTH,
            flexShrink: 0,
            '& .MuiDrawer-paper': {
                width: SIDEBAR_WIDTH,
                boxSizing: 'border-box',
                display: 'flex',
                flexDirection: 'column',
                borderRight: '1px solid',
                borderColor: 'divider',
                backgroundColor: 'background.paper'
            }
        }, children: drawerContent }));
};
export default SidePanel;
